'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logLevel = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

exports.debug = debug;
exports.info = info;
exports.warning = warning;
exports.error = error;
exports.setLogLevel = setLogLevel;
exports.history = history;

var _buffer = require('./buffer');

var _environment = require('./environment');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns an array of formatted messages.
 * @param messages
 * @param prefix
 * @param style
 * @returns {*}
 */
function formatMessages(messages, prefix, style) {
    if ((0, _environment.isPdf)()) {
        messages = messages.map(function (m) {
            if (typeof m === 'function') {
                return 'function<' + m.name + '>';
            }
            if ((typeof m === 'undefined' ? 'undefined' : (0, _typeof3.default)(m)) === 'object') {
                try {
                    return (0, _stringify2.default)(m);
                } catch (e) {
                    return 'OBJECT';
                }
            }
            return m;
        });
        return [[prefix].concat((0, _toConsumableArray3.default)(messages))];
    }

    return ['%c' + prefix, style].concat((0, _toConsumableArray3.default)(messages));
}

var logLevel = exports.logLevel = {
    debug: {
        level: 2,
        handler: function handler(time) {
            var _console;

            for (var _len = arguments.length, messages = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                messages[_key - 1] = arguments[_key];
            }

            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, (0, _toConsumableArray3.default)(formatMessages(messages, '[DEBUG] ' + time, 'background-color: gray; color: white;')));
        }
    },
    info: {
        level: 4,
        handler: function handler(time) {
            var _console2;

            for (var _len2 = arguments.length, messages = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                messages[_key2 - 1] = arguments[_key2];
            }

            // eslint-disable-next-line no-console
            (_console2 = console).info.apply(_console2, (0, _toConsumableArray3.default)(formatMessages(messages, '[INFO]  ' + time + ' ', 'background-color: blue; color: white;')));
        }
    },
    warning: {
        level: 6,
        handler: function handler(time) {
            var _console3;

            for (var _len3 = arguments.length, messages = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                messages[_key3 - 1] = arguments[_key3];
            }

            // eslint-disable-next-line no-console
            (_console3 = console).warn.apply(_console3, (0, _toConsumableArray3.default)(formatMessages(messages, '[WARN]  ' + time + ' ', 'background-color: yellow; color: black')));
        }
    },
    error: {
        level: 8,
        handler: function handler(time) {
            var _console4;

            for (var _len4 = arguments.length, messages = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                messages[_key4 - 1] = arguments[_key4];
            }

            // eslint-disable-next-line no-console
            (_console4 = console).error.apply(_console4, (0, _toConsumableArray3.default)(formatMessages(messages, '[ERROR] ' + time + ' ', 'background-color: red; color: white')));
        }
    }
};

/**
 * The current log level
 * @type {number}
 */
var buffer = new _buffer.Buffer(100);
var currentLogLevel = void 0;
if (window.localStorage) {
    currentLogLevel = window.localStorage.getItem('logLevel');
}
if (!currentLogLevel) {
    currentLogLevel = (0, _environment.isPdf)() ? logLevel.debug.level : logLevel.error.level;
}

/**
 * Main log method
 * @param level
 * @param message
 */
function log(level, time) {
    for (var _len5 = arguments.length, message = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        message[_key5 - 2] = arguments[_key5];
    }

    level = (typeof level === 'undefined' ? 'undefined' : (0, _typeof3.default)(level)) === 'object' ? level.level : level;
    time = (typeof time === 'undefined' ? 'undefined' : (0, _typeof3.default)(time)) === 'object' ? time.toISOString() : time;
    buffer.push({ level: level, time: time, message: message });

    var levelDefinition = logLevel[level];
    if (!levelDefinition || !levelDefinition.handler) {
        var _console5;

        // eslint-disable-next-line no-console
        (_console5 = console).log.apply(_console5, ['[' + level + ']'].concat(message));
        return;
    }

    if (currentLogLevel > levelDefinition.level) {
        return;
    }

    levelDefinition.handler.apply(levelDefinition, [time].concat(message));
}

/**
 * Logs a message as debug.
 * @param messages
 */
function debug() {
    for (var _len6 = arguments.length, messages = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        messages[_key6] = arguments[_key6];
    }

    log.apply(undefined, ['debug', new Date()].concat(messages));
}

/**
 * Logs a message as info.
 * @param messages
 */
function info() {
    for (var _len7 = arguments.length, messages = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        messages[_key7] = arguments[_key7];
    }

    log.apply(undefined, ['info', new Date()].concat(messages));
}

/**
 * Logs a message as warning.
 * @param messages
 */
function warning() {
    for (var _len8 = arguments.length, messages = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        messages[_key8] = arguments[_key8];
    }

    log.apply(undefined, ['warning', new Date()].concat(messages));
}

/**
 * Logs a message as error.
 * @param messages
 */
function error() {
    for (var _len9 = arguments.length, messages = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        messages[_key9] = arguments[_key9];
    }

    log.apply(undefined, ['error', new Date()].concat(messages));
}

/**
 * Sets the current log level.
 * @param level
 */
function setLogLevel(level) {
    level = (typeof level === 'undefined' ? 'undefined' : (0, _typeof3.default)(level)) === 'object' ? level.level : level;
    currentLogLevel = level;
    localStorage.setItem('logLevel', level);
}

/**
 * Allows us to go back in time to look at the log.
 * @param level
 */
function history() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : logLevel.debug;

    var levelBefore = currentLogLevel;
    setLogLevel(level);

    buffer.toArray().forEach(function (element) {
        log.apply(undefined, [element.level, element.time].concat((0, _toConsumableArray3.default)(element.message)));
    });

    setLogLevel(levelBefore);
}

window._log = {
    logLevel: logLevel,
    debug: debug,
    warning: warning,
    info: info,
    error: error,
    setLogLevel: setLogLevel,
    history: history
};